import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _isNil from 'lodash/isNil';
import { isServerSideRendering } from '../../../utils/gatsby';
function getSafeWindow(referenceWindow) {
  var finalWindow = referenceWindow;
  if (!isServerSideRendering() && _isNil(finalWindow)) {
    finalWindow = window;
  }
  return finalWindow;
}
var DimensionUtils = /*#__PURE__*/function () {
  function DimensionUtils() {
    _classCallCheck(this, DimensionUtils);
  }
  _createClass(DimensionUtils, null, [{
    key: "getFromReactReference",
    value: function getFromReactReference(reactReference) {
      if (reactReference && reactReference.current) {
        return reactReference.current.getBoundingClientRect();
      }
      return {};
    }
  }, {
    key: "getRelativeDistanceToWindowBorders",
    value: function getRelativeDistanceToWindowBorders(reactReference) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$thresholdPercent = _ref.thresholdPercentage,
        thresholdPercentage = _ref$thresholdPercent === void 0 ? 0.25 : _ref$thresholdPercent,
        referenceWindow = _ref.referenceWindow;
      var finalWindow = getSafeWindow(referenceWindow);
      var dimensions = this.getFromReactReference(reactReference);
      var windowDimensions = this.getWindowDimensions({
        referenceWindow: finalWindow
      });
      var leftPercentage = dimensions.left / windowDimensions.width;
      var rightPercentage = 1 - dimensions.right / windowDimensions.width;
      return {
        tooCloseToLeft: leftPercentage < thresholdPercentage,
        tooCloseToRight: rightPercentage < thresholdPercentage,
        leftPercentage: leftPercentage,
        rightPercentage: rightPercentage
      };
    }
  }, {
    key: "getWindowDimensions",
    value: function getWindowDimensions() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        referenceWindow = _ref2.referenceWindow;
      var finalWindow = getSafeWindow(referenceWindow);
      if (!_isNil(finalWindow)) {
        return {
          width: finalWindow.screen.width,
          height: finalWindow.screen.height
        };
      }
      return {
        width: 0,
        height: 0
      };
    }
  }]);
  return DimensionUtils;
}();
export default DimensionUtils;